export const NODA_FORM_LINK: string = 'https://noda.live/contact-sales';
export const NODA_FORM_ROUTER_LINK: string = '/contact-sales';
export const NODA_DOCS_LINK: string = 'https://docs.noda.live/';
export const NODA_DOCS_REFERENCE_LINK: string = 'https://docs.noda.live/reference';
export const NODA_CODA_DOCS_LINK: string = 'https://meet-noda.noda.live';
export const NODA_CAREERS_LINK: string = 'https://join.noda.live/';
